import React, { useState } from 'react';
import { ShieldCheck, LogOut, Shield, Users } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';
import { AdminLoginDialog } from './AdminLoginDialog';
import { AdminLeadsDialog } from './AdminLeadsDialog';
import { toast } from 'sonner';

export function Footer() {
  const { isAdmin, logout } = useAuth();
  const [adminOpen, setAdminOpen] = useState(false);

  return (
    <footer className="mt-12 border-t border-slate-200 bg-white/60 backdrop-blur-sm" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Disclaimer */}
        <div className="mb-6 p-4 rounded-xl bg-slate-50 border border-slate-200">
          <p className="text-xs text-slate-500 leading-relaxed">
            <strong className="text-slate-700">Aviso:</strong> Los valores mostrados en esta calculadora son estimaciones basadas en benchmarks de la industria y las variables ingresadas. Los resultados reales dependen de la calidad creativa, la segmentación, el período de optimización del algoritmo y factores externos del mercado. No constituyen una garantía de rendimiento ni una oferta comercial formal.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src="/logo-vitamina-icon.png" alt="Vitamina Online" className="w-8 h-8 rounded-lg" />
            <div>
              <p className="text-sm font-semibold text-slate-900">Vitamina Online</p>
              <p className="text-xs text-slate-500">© {new Date().getFullYear()} · Agencia de Marketing Digital</p>
            </div>
          </div>

          <div className="flex items-center gap-4 flex-wrap justify-center">
            <a
              href="https://vitaminaonline.com.mx/aviso-de-privacidad"
              target="_blank"
              rel="noreferrer noopener"
              className="text-xs font-medium text-slate-600 hover:text-[#1A56DB] transition-colors"
              data-testid="privacy-policy-link"
            >
              Aviso de Privacidad
            </a>
            <a
              href="https://vitaminaonline.com.mx"
              target="_blank"
              rel="noreferrer noopener"
              className="text-xs font-medium text-slate-600 hover:text-[#1A56DB] transition-colors"
              data-testid="website-link"
            >
              vitaminaonline.com.mx
            </a>

            {isAdmin ? (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => { logout(); toast.success('Sesión cerrada.'); }}
                className="gap-1.5 text-xs h-8 text-slate-600 hover:text-red-600"
                data-testid="admin-logout-button"
              >
                <LogOut className="h-3 w-3" />
                Cerrar sesión admin
              </Button>
            ) : (
              <button
                onClick={() => setAdminOpen(true)}
                className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-slate-700 transition-colors"
                data-testid="admin-access-link"
                title="Acceso del equipo"
              >
                <Shield className="h-3 w-3" />
                Acceso interno
              </button>
            )}
          </div>
        </div>
      </div>

      <AdminLoginDialog open={adminOpen} onOpenChange={setAdminOpen} />
    </footer>
  );
}

export function AdminBadge() {
  const { isAdmin, logout, email } = useAuth();
  const [leadsOpen, setLeadsOpen] = useState(false);
  if (!isAdmin) return null;
  return (
    <>
      <div
        className="fixed top-20 right-4 z-40 flex items-center gap-2 px-3 py-2 rounded-full bg-slate-900 text-white shadow-lg border border-amber-400/40"
        data-testid="admin-badge"
      >
        <ShieldCheck className="h-4 w-4 text-amber-400" />
        <span className="text-xs font-semibold hidden sm:inline">Admin · {email?.split('@')[0]}</span>
        <button
          onClick={() => setLeadsOpen(true)}
          className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-white/10 hover:bg-white/20 transition-colors text-[11px] font-semibold"
          data-testid="admin-leads-button"
          title="Ver leads"
        >
          <Users className="h-3 w-3" />
          Leads
        </button>
        <button
          onClick={logout}
          className="text-[10px] uppercase tracking-wider text-slate-300 hover:text-white ml-1"
          title="Cerrar sesión"
        >
          salir
        </button>
      </div>
      <AdminLeadsDialog open={leadsOpen} onOpenChange={setLeadsOpen} />
    </>
  );
}
